import React, {useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import Dropzone from 'react-dropzone';
import * as moment from 'moment'
const filesPath = 'staticfiles'
import {env} from '../../constants/Environment';
import { nanoid } from 'nanoid'
import {StaticfilesNavigation} from './Navigation';

const _ = require('lodash');

export default function Uploader(props) {
    moment.locale('de');
    const firebase = useFirebase()
    const dispatch = useDispatch()
    const [path, setPath] = useState(props.match.params[0].split('/'));
    const firestore = useFirestore();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setPath(props.match.params[0].split('/'));
    }, [props.match.params[0]]);

    useFirestoreConnect({
      collection: 'environments/' + env + '/staticfiles',
      where: ['path', '==', path.join('/').toLowerCase()],
      orderBy: [['created', 'desc']]
    })

    const files = useSelector((state) => state.firestore.ordered['environments/' + env + '/staticfiles']);
    const addNewFolder = (e) => {
        let foldername = prompt('Bitte geben Sie einen Namen für den neuen Ordner ein:');

        if(foldername !== null && foldername.replace(/[^A-z0-9\_\-]/g, '').length > 0){
            firestore.collection('environments/' + env + '/staticfiles').add({
                type: 'folder',
                path: path.join('/').toLowerCase(),
                fullPath: [...path, foldername].join('/'),
                name: foldername,
                created: new Date()
            });
        }
    }

    const removeFolder = (e) => {
        if(confirm('Sind Sie sicher, dass Sie den Ordner löschen möchten?')){
            setIsLoading(true);

            firestore.collection('environments/' + env + '/staticfiles').where('fullPath', '==', '/' + path.join('/')).where('type', '==', 'folder').get().then((docs) => {
                docs.forEach((doc) => {
                    let data = doc.data();

                    if(typeof data.deleted !== 'undefined' && data.deleted)return;
                    if(data.type !== 'folder')return;

                    let parentDir = doc.data().path;

                    firestore.collection('environments/' + env + '/staticfiles').doc(doc.id).set({
                        deleted: true,
                        deletedOn: new Date()
                    }, {
                        mergeFields: ['deleted', 'deletedOn']
                    }).then((success) => {
                        dispatch(RouterActions.push('/staticfiles/files/' + parentDir));
                        setIsLoading(false);
                    });
                });
            }).catch((e) => {
                console.log(e);
            });
        }
    }

    const removeFile = (id) => {
        if(confirm('Sind Sie sicher, dass Sie die Datei löschen möchten?' + "\n" + 'Hinweis: Zugeordnete Dateien bleiben weiterhin bestehen.')){
            setIsLoading(true);

            firestore.collection('environments/' + env + '/staticfiles').where('id', '==', id).get().then((docs) => {
                docs.forEach((doc) => {
                    let data = doc.data();

                    if(typeof data.deleted !== 'undefined' && data.deleted)return;
                    if(data.type !== 'file')return;

                    firestore.collection('environments/' + env + '/staticfiles').doc(doc.id).set({
                        deleted: true,
                        deletedOn: new Date()
                    }, {
                        mergeFields: ['deleted', 'deletedOn']
                    }).then((success) => {
                        setIsLoading(false);
                    });
                });
            }).catch((e) => {
                console.log(e);
            });
        }
    }

    function onFilesDrop(files) {
        const dbPath = 'environments/' + env + '/staticfiles';

        return firebase.uploadFiles(filesPath, files, dbPath, {
            name: (file) => Buffer.from(file.name).toString('base64') + '.' + nanoid(),
            metadataFactory: (uploadRes, firebase, metadata, downloadURL) => {
                let id = metadata.name.split('.');
                let name = Buffer.from(id.shift(), 'base64').toString('ascii');
                id = id.join('.');

                return { filename: metadata.name, path: path.join('/').toLowerCase(), originalName: name, id: id, fileUrl: downloadURL, type: 'file', created: new Date(), ..._.pick(metadata, ['size', 'contentType', 'md5Hash']) }
            }
        });
    }

    return (
        <StaticfilesNavigation breadcrumb={[
            {
                'caption': 'Dateien',
                'href': '/staticfiles/files/'
            },
            ...path.map((p, idx) => {
                return {
                    caption: p,
                    href: '/staticfiles/files/' + path.slice(0, idx + 1).join('/')
                }
            })
        ]} active="files">
            {
            isLoading?
                <Loader active inline />
            :
                <div style={{
                    padding: '0.5em',
                    paddingTop: '1em'
                }}>

                    <Button primary labelPosition="left" icon="plus" content="Neuer Ordner" onClick={addNewFolder}></Button>
                    {
                        (path.length > 0)?
                            <Button color='red' labelPosition="left" icon="trash" content="Ordner löschen" onClick={removeFolder}></Button>
                        :null
                    }

                    <div style={{
                        marginTop: '1em'
                    }}>
                        <Dropzone onDrop={onFilesDrop} >
                        {({getRootProps, getInputProps}) => (
                            <section style={{
                                margin: '0.5em 0'
                            }}>
                            <div {...getRootProps()} style={{
                                padding: '0.5em',
                                cursor: 'pointer',
                                border: '2px dotted #555555',
                                backgroundColor: '#CCFFCC'
                            }}>
                                <input {...getInputProps()} />
                                <p><Icon name="upload" /> Hier klicken oder Dateien hier ablegen, um diese hochzuladen.</p>
                            </div>
                            </section>
                        )}
                        </Dropzone>
                        
                        {
                            (typeof files !== 'undefined' && files !== null)?
                                files.map((file) => {
                                    if(typeof file.deleted !== 'undefined' && file.deleted)return null;

                                    if(file.type === 'folder'){
                                        return (
                                            <div style={{
                                                cursor: 'pointer',
                                                padding: '0.5em 0'
                                            }} onClick={(e) => {
                                                dispatch(RouterActions.push('/staticfiles/files/' + ((file.path.length > 0)?file.path + '/':'') + file.name));
                                            }}>
                                                <Icon name="folder" /> {file.name}
                                            </div>
                                        )
                                    }else{
                                        return null;
                                    }
                                })
                            :null
                        }

                        <div style={{
                            
                        }}>

                        {
                            (typeof files !== 'undefined' && files !== null)?
                                files.map((file) => {
                                    if(typeof file.deleted !== 'undefined' && file.deleted)return null;

                                    if(file.type === 'file'){
                                        return (
                                            <div style={{
                                                padding: '0.5em 0',
                                                display: 'flex'
                                            }}>
                                                <Icon name="file" />
                                                <div style={{
                                                    flexGrow: 1
                                                }}>{file.originalName}</div>
                                                <div>{moment(file.created.toDate()).format('dddd, Do MMMM YYYY, H:mm:ss')}</div>
                                                <div style={{marginLeft: '1em'}}><Button size="tiny" color="grey" onClick={(e) => window.open(file.fileUrl)}>Vorschau</Button></div>
                                                <div style={{marginLeft: '1em'}}><Button size="tiny" color="red" onClick={(e) => removeFile(file.id)}>Datei löschen</Button></div>
                                            </div>
                                        )
                                    }else{
                                        return null;
                                    }
                                })
                            :null
                        }

                        </div>
                    </div>   
                </div>
            }
        </StaticfilesNavigation>
    )
}